
const ajaxRequest = (() => {

    const post = (url, data, contentType, success) => {
        return _makeRequest('POST', url, data, contentType, success);
    }

    const get = (url, data, contentType, success) => {
        return _makeRequest('GET', url, data, contentType, success);
    }

    const _makeRequest = (httpMethod, url, data, contentType, success) => {
        const params = typeof data == 'string' ? data : Object.keys(data).map(
            (k) => { return encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) }
        ).join('&');
        const xhr = new XMLHttpRequest();
        xhr.open(httpMethod, url);
        xhr.onreadystatechange = function() {
            if (xhr.readyState>3 && xhr.status==200) { success(xhr.responseText); }
        };
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        xhr.setRequestHeader('Content-Type', contentType || 'application/x-www-form-urlencoded; charset=UTF-8');
        xhr.send(params);
        return xhr;
    }

    const jsonp = (url, dataObj, timeout) => {
        const params = typeof dataObj == 'string' ? dataObj : Object.keys(dataObj).map(
            (k) => { return encodeURIComponent(k) + '=' + encodeURIComponent(dataObj[k]) }
        ).join('&');
    
        return new Promise((resolve, reject) => {  
            timeout = timeout || 10000; // default timeout     
            const callbackName="jsonp"+(+new Date());
            const head = document.getElementsByTagName('head')[0] || document.documentElement;
            const script = document.createElement('script');
            script.src =`${url}${url.includes('?')?'&':'?'}${params}&callback=${callbackName}&v=1.0`;
            script.async = "true";
    
            window[callbackName] = (data) => {
                cleanUp();
                resolve(data);
            }
    
            script.onerror = () => {
                cleanUp();
                reject( Error("Network error loading " + script.src) );
            }
    
            head.appendChild(script);
            const timeoutFunction = setTimeout(function() {
                cleanUp();
                reject( Error("Request to " + url + " failed to execute callback after " + timeout + "ms.") )  
            }, timeout);
      
            const cleanUp = () => {
                timeoutFunction && clearTimeout(timeoutFunction);
                window[callbackName] && delete window[callbackName];
                script && head.removeChild(script);
            }
    
        } );
    }

    const fetchRequest = async (url, data, method, success) => {
        return await fetch(
            url,
            {
                method: method,
                body: data
            })
            .then((response) => {
                success(response);                 
            })  
            .catch((err) => {
                throw new Error(`Request to ${url} failed!`, err);
            });
    }

    return {
        post,
        get,
        jsonp,
        fetch: fetchRequest,
    };
})();

export { ajaxRequest };